import React from "react";
import { useSelector } from "react-redux";
import style from "src/Assets/css/home/TrendingTagResults.module.css";
import Post from "../home/post";
import CircularProgress from "@material-ui/core/CircularProgress";
import backwardarrow from "src/Assets/images/backwardarrow.png";

const TrendingAsksReuslts = () => {
  const TrendingAskResults = useSelector(
    (state) => state.TagReducer.trendingAsksResults
  );
  return (
    <>
      {TrendingAskResults && Object.keys(TrendingAskResults).length > 0 ? (
        <div className={style.TagResults}>
          <div className={style.TagResultContainer}>
            <a href="/Home">
              <img src={backwardarrow} />
            </a>
            <span className={style.trendingTagHeading}>Trending ASKs</span>
          </div>
          <Post listdata={TrendingAskResults} data={TrendingAskResults} />
        </div>
      ) : (
        <p>no records found</p>
      )}
    </>
  );
};

export default TrendingAsksReuslts;
